import clsx from "clsx";
import React from "react";
import { onRemoveChoice } from "./choices";
import Immutable from "immutable";
import { checkboxesType, notDeletableType } from "../../../common/types/search/search";

interface CriterionChoiceProps {
	choiceKey?: string | number;
	criterionKey: string;
	currentInput?: checkboxesType | Immutable.Map<string, unknown> | string;
	hidden: boolean;
	notDeletable?: notDeletableType;
	onDelete: () => void;
	value: string;
}

export function CriterionChoice({
	choiceKey,
	criterionKey,
	currentInput,
	hidden,
	notDeletable,
	onDelete,
	value,
}: CriterionChoiceProps) {
	const deleteButton = notDeletable?.includes(criterionKey) ? null : (
		<button
			type="button"
			className="tag__remove"
			onClick={() => onRemoveChoice(choiceKey, currentInput, onDelete)}
		>
			{`Remove ${value}`}
		</button>
	);

	const classes = clsx("criterion-choice tag tag-grey", {
		"tag-removable": deleteButton,
		hidden,
	});

	return (
		<li className={classes}>
			<span>{value}</span>
			{deleteButton}
		</li>
	);
}
